import { render, staticRenderFns } from "./add.vue?vue&type=template&id=188e7cd2&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=188e7cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e7cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188e7cd2')) {
      api.createRecord('188e7cd2', component.options)
    } else {
      api.reload('188e7cd2', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=188e7cd2&scoped=true&", function () {
      api.rerender('188e7cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/payment/add.vue"
export default component.exports